export default {"src":"/_next/static/media/vendor-selection.7fabe985.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};